import { configureStore } from '@reduxjs/toolkit'

export enum Notification_Actions {
  ADD_NOTIFICATION = 'ADD_NOTIFICATION',
  NOTIFICATIONS = 'NOTIFICATIONS',
  DELETE_NOTIFICATION = 'DELETE_NOTIFICATION',
}
export enum Theme_Actions {
  THEMES = 'THEMES',
  CHANGE_THEME = 'CHANGE_THEME',
  THEME = 'THEME',
}

export type NotificationState = ReturnType<typeof notificationReducer>
export type ThemeState = ReturnType<typeof themeReducer>

const defaultState = {
  NOTIFICATIONS: [],
  THEMES: ['dark', 'default'],
  THEME: null,
}

const notificationReducer = (state: any = defaultState, action: any) => {
  switch (action.type) {
    case Notification_Actions.NOTIFICATIONS:
      return state.NOTIFICATIONS

    case Notification_Actions.ADD_NOTIFICATION:
      return {
        ...state,
        NOTIFICATIONS: [...state.NOTIFICATIONS, action.payload],
      }

    case Notification_Actions.DELETE_NOTIFICATION:
      return {
        ...state,
        NOTIFICATIONS: state.NOTIFICATIONS.filter(
          (object: any) => object.id !== action.payload.id,
        ),
      }

    default:
      return state
  }
}

const themeReducer = (state: any = defaultState, action: any) => {
  switch (action.type) {
    case Theme_Actions.THEME:
      return state.THEME

    case Theme_Actions.CHANGE_THEME:
      if (state.THEMES.includes(action.payload)) {
        localStorage.setItem('theme', action.payload)
        return {
          ...state,
          THEME: action.payload,
        }
      }
      return { ...state }

    case Theme_Actions.THEMES:
      return {
        ...state,
        THEMES: state.THEMES,
      }

    default:
      return state
  }
}

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    notifications: notificationReducer,
  },
})
